/**
 * HTML DIV elements builder.
 *
 * @author Stanislav Kalashnik <darkpark.main@gmail.com>
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

/**
 * Create a new HTML DIV element.
 *
 * @param {string|null} [className] - element class name/names
 * @param {...*} [content] - element content (primitive value/values or other nodes)
 *
 * @return {Element} HTML DIV element
 *
 * @example
 * div();
 * div('className', 'some text');
 * div('className anotherClassName', div(), div());
 */
module.exports = function ( className ) {
    var node = document.createElement('div'),
        argument, index;

    if ( className ) {
        node.className = className;
    }

    for ( index = 1; index < arguments.length; index += 1 ) {
        argument = arguments[index];

        node.appendChild(
            argument instanceof Element ? argument : document.createTextNode(argument)
        );
    }

    return node;
};
